import React from 'react';

interface PlaceholderIconProps {
  label: string;
  className?: string;
  colorClass?: string;
  imageUrl?: string;
  imageClassName?: string; 
  style?: React.CSSProperties;
}

const PlaceholderIcon: React.FC<PlaceholderIconProps> = ({ 
  label, 
  className,
  colorClass = 'bg-transparent border-transparent', 
  imageUrl,
  imageClassName = "object-contain",
  style
}) => {
  // Normalize label for case-insensitive comparison
  const normalizedLabel = label.toLowerCase();

  // Decide size based on label
  // const imgSize = (normalizedLabel === "merlin" || normalizedLabel === "morgana")
  //   ? { height: "100%", width: "100%" }
  //   : { height: "100%", width: "100%" };

  return (
    <div
      className={`${colorClass} border rounded-md flex items-center justify-center text-xs text-gray-200 p-1 text-center overflow-hidden ${className}`}
      style={style}
    >
      {imageUrl ? (
        <img 
          src={imageUrl} 
          alt={label} 
          className={`w-full h-full ${imageClassName}`}
          style={{ width: '100%', height: '100%' }}
        />
      ) : (
        <span className="text-xs text-center">{label}</span>
      )}
    </div>
  );
};

export default PlaceholderIcon;
